import { render, staticRenderFns } from "./DetailBlock.vue?vue&type=template&id=a92f5920&scoped=true&lang=pug&"
import script from "./DetailBlock.vue?vue&type=script&lang=js&"
export * from "./DetailBlock.vue?vue&type=script&lang=js&"
import style0 from "./DetailBlock.vue?vue&type=style&index=0&id=a92f5920&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a92f5920",
  null
  
)

export default component.exports